const radioCss = new CSSStyleSheet();
radioCss.insertRule(`
    input[type="radio"] + label::before {
        inset: 0 !important;
        margin-block: auto;
    }
`);
radioCss.insertRule(`
    input[type="radio"]:checked + label::after {
        inset: 0;
        margin-block: auto;
        inset-inline-start: 3px !important;
        inset-block-start: 0 !important;
    }
`);

/**
 * Provides custom styles for fw-radio element.
 * @param element Element to provide styles for.
 */
export function provideRadioStyles(element: HTMLElement): void {
    const root = element.shadowRoot;

    if (root !== null && !root.adoptedStyleSheets.includes(radioCss)) {
        root.adoptedStyleSheets.push(radioCss);
    }
}
